/// <amd-module name="Agile/Sprints/Directory/Redux/SprintDirectoryModule" />
import { sprintDirectoryReducer } from "Agile/Sprints/Directory/Redux/SprintDirectoryReducer";
import { sprintDirectorySaga } from "Agile/Sprints/Directory/Redux/SprintDirectorySaga";
import { ISprintDirectoryAwareState } from "Agile/Sprints/Directory/SprintDirectoryContracts";
import { ISagaModule } from "redux-dynamic-modules-saga";

export const SprintDirectoryModule: ISagaModule<ISprintDirectoryAwareState> = {
    id: "sprint-directory",
    reducerMap: {
        sprintDirectoryState: sprintDirectoryReducer
    },
    sagas: [sprintDirectorySaga]
};
